export const GET_PHONE_NUMBER_VALUE = "getPhoneNumberValue"

export default {
  [GET_PHONE_NUMBER_VALUE]: (state: PhoneNumber): PhoneNumberPair => state.phoneNumberValue
}
